import React from 'react';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { useProjectContext } from '@atlassian/jira-providers-project-context/src/index.tsx';
import { ProjectNotFound } from '@atlassian/jira-servicedesk-spa-commons/src/common/utils/errors/index.tsx';
import { NotificationLogsTabLayout } from './notification-logs-tab-layout/index.tsx';

export const NotificationLogsPage = () => {
	const { data: projectContext } = useProjectContext();
	if (!projectContext) {
		fireErrorAnalytics({
			meta: {
				id: 'ProjectContextNULL',
				packageName: 'jiraSpaAppsServicedeskNotificationLogs',
				teamName: 'spartans',
			},
			sendToPrivacyUnsafeSplunk: true,
		});
		return null;
	}
	const isProjectAdmin = Boolean(projectContext?.isProjectAdmin);
	if (!isProjectAdmin) {
		fireErrorAnalytics({
			meta: {
				id: 'UserIsNotProjectAdmin',
				packageName: 'jiraSpaAppsServicedeskNotificationLogs',
				teamName: 'spartans',
			},
			sendToPrivacyUnsafeSplunk: true,
		});
		return (
			<div data-testid="spa-apps-servicedesk-notification-logs.ui.notification-logs-page.project-not-found">
				<ProjectNotFound />
			</div>
		);
	}

	return <NotificationLogsTabLayout projectContext={projectContext} />;
};
